import React, { useState, useEffect, useRef } from 'react';
import Button from '../../../components/ui/Button';

import Icon from '../../../components/AppIcon';
import { useWaitlist } from '../../../contexts/WaitlistContext';

const WaitlistSection = () => {
  const { loading } = useWaitlist();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => { if (entries[0].isIntersecting) { setIsVisible(true); observer.disconnect(); } },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const handleJoinWaitlist = () => {
    window.open('https://depthme.app', '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="waitlist" ref={sectionRef} className="relative py-20 px-6 overflow-hidden">
      {/* Image1 radial accent */}
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="/image1.jpg"
          alt=""
          aria-hidden="true"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[140%] h-[140%] object-cover opacity-[0.18] blur-xl"
        />
        <div className="absolute inset-0 bg-radial-gradient" style={{ background: 'radial-gradient(ellipse at center, transparent 30%, var(--color-background) 80%)' }} />
      </div>
      <div className="relative z-10 max-w-4xl mx-auto">
        {/* Main Header */}
        <div className={`text-center mb-12 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-6">
            Begin training{' '}
            <span className="text-gradient">your mind.</span>
          </h2>

          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Get early access to DepthMe — personalized guidance in your own voice,
            four daily rituals, and a practice built around your real situation.
          </p>
        </div>


        {/* Join Waitlist Button */}
        <div className={`text-center mb-16 transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <Button
            onClick={handleJoinWaitlist}
            variant="default"
            size="lg"
            className="violet-glow text-lg py-4 px-12"
            iconName="ArrowRight"
            iconPosition="right"
          >
            Open App
          </Button>
        </div>

        {/* Final Value Props */}
        <div className={`grid md:grid-cols-3 gap-6 transition-all duration-1000 delay-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="text-center">
            <Icon name="Mic" size={32} className="text-primary mx-auto mb-3" />
            <h4 className="font-semibold text-foreground mb-2">Your Voice</h4>
            <p className="text-sm text-muted-foreground">
              Guidance delivered in your own cloned voice — familiar, believable, effective
            </p>
          </div>

          <div className="text-center">
            <Icon name="Gift" size={32} className="text-accent mx-auto mb-3" />
            <h4 className="font-semibold text-foreground mb-2">Exclusive Pricing</h4>
            <p className="text-sm text-muted-foreground">
              Beta pricing locked in for life for early members
            </p>
          </div>

          <div className="text-center">
            <Icon name="Shield" size={32} className="text-primary mx-auto mb-3" />
            <h4 className="font-semibold text-foreground mb-2">Private by Design</h4>
            <p className="text-sm text-muted-foreground">
              Zero-knowledge encryption — your entries stay yours
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
export default WaitlistSection;